import React, { useState, useEffect, useRef } from 'react';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    TextField,
    MenuItem,
    Button,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TablePagination,
    Box,
    InputAdornment,
    Typography,
    IconButton,
    Menu
} from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import styles from './styles.module.css';
import close from '../../../images/PlayerHistoryPopup/close.svg';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCasinoResults } from '../../../store/slices/casinoResultsSlice';
import dropdownIcon from "../../../images/PlayerHistoryPopup/dropdownIcon.svg";
import calendar from '../../../images/PlayerHistoryPopup/calendar.svg';
import { useSearchParams } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// ✅ Game-specific result popups (same as FooterLinks.jsx)
import DragonTigerResultsPopup from './DragonTigerResultsPopup';
import Lucky7ResultsPopup from '../Lucky7/Lucky7ResultsPopup';
import BollywoodResultsPopup from '../Bollywood_Casino/BollywoodResultsPopup';
import AndarBaharResult from '../AndarBahar/Result';
import Card32Result from '../Card32/Card32Result';
import DragonTigerLionResultPopup from '../Dragon_Tiger_Lion/Dragon_Tiger_LionResultPopup';
import TeenPatiTtweentyResultPopup from '../TeenPatiTtweenty/TeenPatiTtweentyResultPopup';
import TwocardResultPopup from '../TwoCardTeenPati/TwocardResultPopup ';
import AAAResultsPopup from '../Amar_Akbar_Anthony/AAAResultsPopup';
import BaccaratResultPopup from '../Baccarat/BaccaratResultPopup';
import OneDayDragonTigerResultsPopup from '../Day1DragonTiger/OneDayDragonTigerResultsPopup';
import { aaaroundresult, andarbaharroundresult, baccaratroundresult, bollywoodroundresult, card32roundresult, dragontigerroundresult, dtlroundresult, lucky7roundresult, onedaydtroundresult, teenpattiroundresult, twocardroundresult } from '../../../store/slices/casinoresultwinnerSlice';


const CasinoResultsPopup = ({ open, onClose, gameName }) => {
    const handleClose = onClose || (() => window.history.back());
    const dispatch = useDispatch();
    const { records, total, loading } = useSelector((state) => state.casinoResults);
    const [selectedRow, setSelectedRow] = useState(null);
 const { data: winnerRoundData, loading: winnerLoading, error: winnerError } = useSelector((state) => state.winner);

const activeGameRef = useRef(null);
    const gameOptions = [
        { label: 'One Day Dragon Tiger', value: 'One Day Dragon Tiger' },
        { label: 'Amar Akbar Anthony', value: 'Amar Akbar Anthony' },
        { label: 'Andar Bahar', value: 'Andar Bahar' },
        { label: 'Baccarat', value: 'Baccarat' },
        { label: 'Bollywood Casino', value: 'Bollywood Casino' },
        { label: 'Card32', value: 'Card32' },
        { label: 'Dragon Tiger', value: 'Dragon Tiger' },
        { label: 'Dragon Tiger Lion', value: 'Dragon Tiger Lion' },
        { label: 'Lucky7', value: 'Lucky7' },
        { label: 'Two Card Teen Patti', value: 'Two Card Teen Patti' },
        { label: 'Tenn Patti T20', value: 'Tenn Patti T20' },
        { label: 'Roulette', value: 'Roulette' },
    ];
    const gameConfig = {
        'Dragon Tiger':          { gameId: 6,  popupKey: 'dragonTiger',     thunk: dragontigerroundresult },
        'Dragon Tiger Lion':     { gameId: 7,  popupKey: 'dragonTigerLion', thunk: dtlroundresult },
        'Lucky7':                { gameId: 4,  popupKey: 'lucky7',          thunk: lucky7roundresult },
        'Bollywood Casino':      { gameId: 8,  popupKey: 'bollywood',       thunk: bollywoodroundresult },
        'Andar Bahar':           { gameId: 5,  popupKey: 'andarBahar',      thunk: andarbaharroundresult },
        'Card32':                { gameId: 12, popupKey: 'card32',          thunk: card32roundresult },
        'Tenn Patti T20':        { gameId: 1,  popupKey: 'teenPattiT20',    thunk: teenpattiroundresult },
        'Two Card Teen Patti':   { gameId: 9,  popupKey: 'twoCard',         thunk: twocardroundresult },
        'Amar Akbar Anthony':    { gameId: 11, popupKey: 'aaa',             thunk: aaaroundresult }, 
        'Baccarat':              { gameId: 10, popupKey: 'baccarat',        thunk: baccaratroundresult },
        'One Day Dragon Tiger':  { gameId: 13, popupKey: 'oneDayDT',        thunk: onedaydtroundresult },
        'Roulette':              { gameId: 3,  popupKey: null,              thunk: null }, 
    };

    const [selectedDate, setSelectedDate] = useState(new Date());
    const oneMonthAgo = new Date();
oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
    const [gameFilter, setGameFilter] = useState(gameName);
    const [gameAnchorEl, setGameAnchorEl] = useState(null);
    const openGameMenu = Boolean(gameAnchorEl);
    const dateInputRef = useRef(null);

    const [pageSize, setPageSize] = useState(10);
    const [pageSizeAnchorEl, setPageSizeAnchorEl] = useState(null);
    const openPageSizeMenu = Boolean(pageSizeAnchorEl);
    const pageSizeOptions = [10, 20, 50, 100];
    const [searchParams] = useSearchParams();
    const gameFromUrl = searchParams.get('game');


    const [activePopup, setActivePopup] = useState(null);

    const CustomDateInput = React.forwardRef(({ value, onClick, placeholder }, ref) => (
        <Box
            className={styles.CasinoFilterBox1}
            onClick={onClick}
            ref={ref}
            sx={{ cursor: 'pointer' }}
        >
            <Typography className={styles.Casinofiltertext1}>
                {value || placeholder}
            </Typography>
            <img src={calendar} alt="Calendar" />
        </Box>
    ));

    const gameTypeToLabel = (type) => {
        const map = {
            'Dragon_Tiger': 'Dragon Tiger',
            'dragon_tiger': 'Dragon Tiger',
            'Dragon_Tiger_Lion': 'Dragon Tiger Lion',
            'dragon_tiger_lion': 'Dragon Tiger Lion',
            'Bollywood_Casino': 'Bollywood Casino',
            'Lucky7': 'Lucky7',
            'AAA': 'Amar Akbar Anthony',
            'TwoCardTeenPati': 'Two Card Teen Patti',
            'card32': 'Card32',
            'TeenPatiTtweenty': 'Tenn Patti T20',
            'Baccarat': 'Baccarat',
            'andarbahar': 'Andar Bahar',
            'One_Day_Dragon_Tiger': 'One Day Dragon Tiger',
        };
        return map[type] || '';
    };

    // ✅ gameFilter (label) ke hisaab se decide karo kaunsa popup khulega
    const labelToPopupKey = {
        'Dragon Tiger': 'dragonTiger',
        'Dragon Tiger Lion': 'dragonTigerLion',
        'Lucky7': 'lucky7',
        'Bollywood Casino': 'bollywood',
        'Andar Bahar': 'andarBahar',
        'Card32': 'card32',
        'Tenn Patti T20': 'teenPattiT20',
        'Two Card Teen Patti': 'twoCard',
        'Amar Akbar Anthony': 'aaa',
        'Baccarat': 'baccarat',
        'One Day Dragon Tiger': 'oneDayDT',
      
    };

const getResultData = () => selectedRow;
const handleWinnerClick = async (row) => {
    const config = gameConfig[gameFilter];
    if (!config) return;

    setSelectedRow(row);
    if (config.popupKey) setActivePopup(config.popupKey);

    if (config.thunk) {
        try {
            const apiResponse = await dispatch(
                config.thunk({ roundId: row.roundId, gameId: config.gameId })
            ).unwrap();
            const normalized = apiResponse?.data ?? apiResponse?.result ?? apiResponse;

            setSelectedRow((prev) => {
                // sirf tab update karo jab kuch naya add ho raha ho
                const merged = { ...prev, ...normalized };
                if (JSON.stringify(merged) === JSON.stringify(prev)) return prev; // avoid re-render
                return merged;
            });
        } catch (err) {
            console.error(err);
        }
    }
};
    const closeAllPopups = () => {
        setActivePopup(null);
        setSelectedRow(null);
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [gotoValue, setGotoValue] = useState('');

    const totalRecords = total || records.length;
    const totalPages = Math.max(1, Math.ceil(totalRecords / pageSize));

    const paginatedRecords = records.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
    );

    const fetchWithPagination = (page = currentPage, size = pageSize) => {
        if (!gameFilter) return;
        dispatch(fetchCasinoResults({
            game: gameFilter,
            date: selectedDate ? selectedDate.toISOString().split('T')[0] : undefined,
            limit: size,
            offset: (page - 1) * size,
        }));
    };

    useEffect(() => {
        setCurrentPage(1);
        setGotoValue('');
    }, [pageSize]);

    const handleDateChange = (e) => {
        setSelectedDate(e.target.value);
    };

    const handleGameSelect = (value) => {
        setGameFilter(value);
        setGameAnchorEl(null);
    };

    const handleSubmit = () => {
        if (!gameFilter) return;
        setCurrentPage(1);
        setGotoValue('');
        dispatch(fetchCasinoResults({
            game: gameFilter,
            date: selectedDate ? selectedDate.toISOString().split('T')[0] : undefined,
            limit: pageSize,
            offset: 0,
        }));
    };

    const handleFirst = () => { setCurrentPage(1); fetchWithPagination(1); setGotoValue(''); };
    const handlePrevious = () => { const p = Math.max(1, currentPage - 1); setCurrentPage(p); fetchWithPagination(p); setGotoValue(''); };
    const handleNext = () => { const p = Math.min(totalPages, currentPage + 1); setCurrentPage(p); fetchWithPagination(p); setGotoValue(''); };
    const handleLast = () => { setCurrentPage(totalPages); fetchWithPagination(totalPages); setGotoValue(''); };

    const handleGotoPage = (e) => {
        if (e.key === 'Enter') {
            const page = parseInt(gotoValue);
            if (!isNaN(page) && page >= 1 && page <= totalPages) {
                setCurrentPage(page);
                fetchWithPagination(page);
            }
        }
    };

    useEffect(() => {
        const effectiveGame = gameName || gameFromUrl;
        if (open !== false) {
            setCurrentPage(1);
            setGotoValue('');
            if (effectiveGame) {
                setGameFilter(effectiveGame);
                dispatch(fetchCasinoResults({
                    game: effectiveGame,
                    date: selectedDate ? selectedDate.toISOString().split('T')[0] : undefined,
                    limit: pageSize,
                    offset: 0,
                }));
            }
        }
    }, [open, gameName, gameFromUrl]);

    const isFirst = currentPage === 1;
    const isLast = currentPage === totalPages;
    useEffect(() => {
        console.log('🟣 [CasinoResultsPopup] winnerRoundData changed:', winnerRoundData);
    }, [winnerRoundData]);

    return (
        <Box className={styles.Main_Container}>

            <Box className={styles.PopupHeadBox}>
                <Typography className={styles.PopupTitleText}>Casino Results</Typography>
                <IconButton className={styles.PopupCloseButton} onClick={handleClose}>
                    <img src={close} alt="Close" />
                </IconButton>
            </Box>

            <Box className={styles.PopupContent}>

     <DatePicker
    selected={selectedDate}
    onChange={(date) => setSelectedDate(date)}
    dateFormat="dd/MM/yyyy"
    customInput={<CustomDateInput placeholder="Select Date" />}
    popperPlacement="bottom-start"
    minDate={oneMonthAgo}
    maxDate={new Date()}
/>
                <Box className={styles.FilterBox_containerCasino}>

          <Box
    className={styles.CasinoFilterBox2}
    sx={{  cursor: 'not-allowed', pointerEvents: 'none' }}
>
    <Typography className={styles.Casinofiltertext2}>
        {gameFilter || 'Select Game'}
    </Typography>
    <img src={dropdownIcon} alt="DownIcon" />
</Box>

                    <Box className={styles.FilterInnerBox}>
                        <Typography className={styles.filtertextshow}>Show</Typography>
                        <Box
                            className={styles.FilterBoxCasinoShow}
                            onClick={(e) => setPageSizeAnchorEl(e.currentTarget)}
                        >
                            <Typography className={styles.filtertextCasinoShow}>{pageSize}</Typography>
                            <img src={dropdownIcon} alt="DownIcon" />
                        </Box>
                        <Typography className={styles.filtertextCasinoEntries}>Entries</Typography>
                    </Box>
                </Box>

                <Button className={styles.SubmitButton} onClick={handleSubmit}>
                    <Typography className={styles.SubmitText}>Submit</Typography>
                </Button>

                {/* <Box sx={{ width: '100%' }}>
                    <Box className={styles.PlayerHistoryTableHeadRow} sx={{ display: 'flex' }}>
                        <Box className={styles.RoundidBox} sx={{ flex: 1, borderRight: '1px solid #ccc' }}>
                            <Box className={styles.PlayerHistoryTableHeadCell2}>Round ID</Box>
                        </Box>
                        <Box className={styles.PlayerHistoryTableHeadCell} sx={{ flex: 1 }}>
                            Winners
                        </Box>
                    </Box>

                    <Box sx={{ width: '100%', maxHeight: '350px', overflowY: 'auto' }}>
                        {records.length > 0 ? (
                            records.map((row, idx) => (
                                <Box key={idx} className={styles.PlayerHistoryTableRow}>
                                    <Box className={styles.TableCell_box}>
                                        <Typography className={styles.TableCell_txt}>{row.roundId}</Typography>
                                    </Box>
                                    <Box sx={{ width: '1px', background: '#E0E0E0', alignSelf: 'stretch' }} />
                                    <Box
                                        className={styles.TableCell_box2}
                                        onClick={() => handleWinnerClick(row)}
                                        sx={{ cursor: 'pointer' }}
                                    >
                                        <Typography className={styles.TableCell_txt2}>{row.winner}</Typography>
                                    </Box>
                                </Box>
                            ))
                        ) : (
                            <Box sx={{ textAlign: 'center', padding: '16px' }}>
                                <Typography className={styles.TableCell_txt}>No records found</Typography>
                            </Box>
                        )}
                    </Box>
                </Box> */}



                  <Box sx={{ width: '100%' }}>
                  <Box className={styles.gridTableHead}>
    <Box className={styles.gridCellHead}>Round ID</Box>
    <Box className={styles.gridCellHead}>Winner</Box>
</Box>

  <Box sx={{ width: '100%' }}>
    {records.length > 0 ? (
        records.map((row, idx) => (
            <Box key={idx} className={styles.gridTableRow}>
                <Box className={styles.gridCell}>
                    <Typography className={styles.TableCell_txt}>{row.roundId}</Typography>
                </Box>
                <Box
                    className={styles.gridCell}
                     onClick={() => handleWinnerClick(row)}
                    sx={{ cursor: 'pointer' }}
                >
                    <Typography className={styles.TableCell_txt2}>{row.winner}</Typography>
                </Box>
            </Box>
        ))
    ) : (
        <Box sx={{ textAlign: 'center', padding: '16px' }}>
            <Typography className={styles.TableCell_txt}>No records found</Typography>
        </Box>
    )}
</Box>
                </Box>

                <Box className={styles.FilterBoxesBody}>
                    {[
                        { label: 'First', onClick: handleFirst, disabled: isFirst },
                        { label: 'Previous', onClick: handlePrevious, disabled: isFirst },
                        { label: 'Next', onClick: handleNext, disabled: isLast },
                        { label: 'Last', onClick: handleLast, disabled: isLast },
                    ].map(({ label, onClick, disabled }) => (
                        <Box
                            key={label}
                            className={styles.FilterBox_boxes}
                            onClick={!disabled ? onClick : undefined}
                            sx={{
                                cursor: disabled ? 'not-allowed' : 'pointer',
                                opacity: disabled ? 0.4 : 1,
                                userSelect: 'none',
                            }}
                        >
                            <Typography className={styles.FilterBox_text}>{label}</Typography>
                        </Box>
                    ))}
                </Box>

                <Box className={styles.PageInfoBox}>
                    <Typography className={styles.PageInfoText}>Page</Typography>
                    <Typography className={styles.PageInfoText2}>
                        {currentPage} of {totalPages}
                    </Typography>
                    <Typography className={styles.PageInfoText3}>|</Typography>
                    <Typography className={styles.PageInfoTextGoTo}>Goto page</Typography>
                    <Box
                        component="input"
                        type="number"
                        value={gotoValue}
                        min={1}
                        max={totalPages}
                        onChange={(e) => setGotoValue(e.target.value)}
                        onKeyDown={handleGotoPage}
                        placeholder={String(currentPage)}
                        className={`${styles.PageInfoInputBox} ${styles.PageInfoInputText}`}
                    />
                </Box>
            </Box>

            <Menu anchorEl={gameAnchorEl} open={openGameMenu} onClose={() => setGameAnchorEl(null)}>
                {gameOptions
                    .filter((option) => option.value !== gameFilter)
                    .map((option, idx) => (
                        <MenuItem key={idx} onClick={() => handleGameSelect(option.value)}>
                            {option.label}
                        </MenuItem>
                    ))}
            </Menu>

            <Menu anchorEl={pageSizeAnchorEl} open={openPageSizeMenu} onClose={() => setPageSizeAnchorEl(null)}>
                {pageSizeOptions.map((size) => (
                    <MenuItem
                        key={size}
                        selected={size === pageSize}
                        onClick={() => {
                            setPageSize(size);
                            setPageSizeAnchorEl(null);
                        }}
                    >
                        {size}
                    </MenuItem>
                ))}
            </Menu>

            {/* ✅ Sirf wahi popup khulega jo gameFilter se match kare */}
            <DragonTigerResultsPopup
                open={activePopup === 'dragonTiger'}
                onClose={closeAllPopups}
                resultData={getResultData()}
            />
            <DragonTigerLionResultPopup
                open={activePopup === 'dragonTigerLion'}
                onClose={closeAllPopups}
        resultData={getResultData()}
            />
            <Lucky7ResultsPopup
                open={activePopup === 'lucky7'}
                onClose={closeAllPopups}
               resultData={getResultData()}
            />
            <BollywoodResultsPopup
                open={activePopup === 'bollywood'}
                onClose={closeAllPopups}
              resultData={getResultData()}
            />
            <AndarBaharResult
                open={activePopup === 'andarBahar'}
                onClose={closeAllPopups}
         resultData={getResultData()}
            />
            <Card32Result
                open={activePopup === 'card32'}
                onClose={closeAllPopups}
              resultData={getResultData()}
            />
            <TeenPatiTtweentyResultPopup
                open={activePopup === 'teenPattiT20'}
                onClose={closeAllPopups}
               resultData={getResultData()}
            />
            <TwocardResultPopup
                open={activePopup === 'twoCard'}
                onClose={closeAllPopups}
                resultData={getResultData()}
            />
            <AAAResultsPopup
                open={activePopup === 'aaa'}
                onClose={closeAllPopups}
               resultData={getResultData()}
            />
            <BaccaratResultPopup
                open={activePopup === 'baccarat'}
                onClose={closeAllPopups}
             resultData={getResultData()}
            />
            <OneDayDragonTigerResultsPopup
                open={activePopup === 'oneDayDT'}
                onClose={closeAllPopups}
             resultData={getResultData()}
            />
        </Box>
    );
};

export default CasinoResultsPopup;